import React from 'react';
import { colors, spacing } from '../design-system/tokens';

interface CardContainerProps {
  children: React.ReactNode;
  className?: string;
  variant?: 'primary' | 'secondary' | 'tertiary';
  style?: React.CSSProperties;
}

export const CardContainer: React.FC<CardContainerProps> = ({ 
  children,
  className = '',
  variant = 'secondary',
  style = {}
}) => {
  const getBackgroundColor = () => {
    switch (variant) {
      case 'primary':
        return colors.background.primary;
      case 'secondary':
        return colors.background.secondary;
      case 'tertiary':
        return colors.background.tertiary;
      default:
        return colors.background.secondary;
    }
  };

  const getBorder = () => {
    if (variant === 'tertiary') {
      return `6px solid ${colors.background.tertiary}`;
    }
    return `2px solid ${colors.border.default}`;
  };

  const getBorderRadius = () => {
    return variant === 'tertiary' ? '18px' : '12px';
  };

  return (
    <div
      className={className}
      style={{
        backgroundColor: getBackgroundColor(),
        border: getBorder(),
        borderRadius: getBorderRadius(),
        padding: variant === 'tertiary' 
          ? spacing.xl 
          : `${spacing.figma.cardPaddingY} ${spacing.figma.cardPaddingX}`,
        display: 'flex',
        flexDirection: 'column',
        gap: spacing.figma.sectionGap,
        ...style
      }}
    >
      {children}
    </div>
  );
};